import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"upload\">\n<g id=\"upload_Down 24px\">\n<path id=\"upload_Vector\" d=\"M4.5 3.75L13.5 3.75M9 6V15M9 6L6.375 8.625M9 6L11.625 8.625\" stroke=\"#5A90DC\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol